import { Observable } from "../events";
import { isValidable } from "../types";
import { ValidableBase } from "../validable";
export class Collection extends ValidableBase {
    static Empty() {
        return new Collection();
    }
    constructor(...items) {
        super();
        this._items = Array.from(items);
    }
    get addedObservable() {
        if (!this._addedObservable) {
            this._addedObservable = new Observable();
        }
        return this._addedObservable;
    }
    get removedObservable() {
        if (!this._removedObservable) {
            this._removedObservable = new Observable();
        }
        return this._removedObservable;
    }
    get count() {
        return this._items.length;
    }
    *get(predicate, sorted) {
        for (const l of this._items ?? []) {
            if (!predicate || predicate(l))
                yield l;
        }
    }
    add(...item) {
        const added = this._addInternal(item);
        if (added?.length) {
            if (this._addedObservable && this._addedObservable.hasObservers()) {
                this._addedObservable.notifyObservers(added, -1, this, this);
            }
            this.invalidate();
        }
    }
    remove(...item) {
        const removed = this._removeInternal(item);
        if (removed?.length) {
            if (this._removedObservable && this._removedObservable.hasObservers()) {
                this._removedObservable.notifyObservers(removed, -1, this, this);
            }
            this.invalidate();
        }
    }
    clear() {
        if (this._items) {
            const toRemove = Array.from(this._items);
            for (const l of toRemove) {
                this.remove(l);
            }
        }
    }
    dispose() {
        this.clear();
        this._addedObservable?.clear();
        this._removedObservable?.clear();
    }
    [Symbol.iterator]() {
        let pointer = 0;
        let items = this._items;
        const iterator = {
            next() {
                if (pointer < items.length) {
                    return {
                        done: false,
                        value: items[pointer++],
                    };
                }
                return {
                    done: true,
                    value: null,
                };
            },
            [Symbol.iterator]() {
                return this;
            },
        };
        return iterator;
    }
    get isValid() {
        if (!super.isValid) {
            return false;
        }
        return (this._items.every((l) => {
            if (isValidable(l)) {
                return l.isValid;
            }
            return true;
        }) ?? true);
    }
    _doValidate() {
        for (const i of this._items) {
            if (isValidable(i)) {
                i.validate();
            }
        }
    }
    _addInternal(items) {
        this._items.push(...items);
        return items;
    }
    _removeInternal(items) {
        let removed = [];
        for (const item of items) {
            const i = this._items.indexOf(item);
            if (i >= 0) {
                removed.push(...this._items.splice(i, 1));
            }
        }
        return removed;
    }
}
//# sourceMappingURL=collection.js.map